<template>
    <div class="card pipeline-list p-2">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Quotation Date</th>
                        <th>Quotation No</th>
                        <th>Quotation Amount</th>
                        <th>Customer Name</th>
                        <th>Submission Date</th>
                        <th>Validity Till Date</th>
                        <th>Last Update - Notes</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in quotationList" :key="index">
                        <td>{{ item.created_at.split('T')[0] }}</td>
                        <td>{{ item.quotation_number }}</td>
                        <td>{{ item.total_amount }}</td>
                        <td>{{ item.contact_profile_name }}</td>
                        <td>{{ item.date }}</td>
                        <td>{{ item.expiry_date }}</td>
                        <td>{{ item.description }}</td>
                        <td>{{ item.status }}</td>
                        <td>
                            <button class="btn btn-primary btn-sm"
                                @click="goToEdit(item.id)"
                                style="cursor: pointer"
                            >
                                <i class="fas fa-eye"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <p v-if="!quotationList.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();

const props = defineProps({
    quotationList: Array,
})

const goToEdit = (id) => {
    router.push({
        name: 'edit-quotation',
        query: route.query,
        params: {
            ...route.params,
            quotationId: id
        }
    })
}
</script>

<style scoped>
.pipeline-list{
    min-height: 200px
}
</style>